import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const HeartLockedShape = ({
  width = 36,
  height = 36,
  fillColor = '#FFF',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 56 56"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5833 17.0081V16.3333C14.5833 12.1123 15.8584 8.69245 18.3209 6.33611C20.7702 3.99235 24.1691 2.91666 28 2.91666C31.8309 2.91666 35.2298 3.99235 37.6791 6.33611C40.1417 8.69245 41.4167 12.1123 41.4167 16.3333V17.0081C45.8127 18.6374 49 23.0377 49 28.2315C49 37.1875 42.0737 42.3537 36.1769 46.7525C35.564 47.2096 34.9622 47.6586 34.3803 48.1026C32.2 49.7665 30.1 51.3333 28 51.3333C25.9 51.3333 23.8 49.7665 21.6196 48.1026C21.0379 47.6586 20.4361 47.2096 19.8232 46.7525C13.9262 42.3537 7 37.1875 7 28.2315C7 23.0377 10.1874 18.6374 14.5833 17.0081ZM18.0833 16.3333C18.0833 12.8224 19.1271 10.4089 20.7407 8.86488C22.3674 7.30829 24.8019 6.41666 28 6.41666C31.1981 6.41666 33.6327 7.30829 35.2595 8.86488C36.873 10.4089 37.9167 12.8224 37.9167 16.3333V16.3364C34.7314 16.2601 31.2422 17.577 28 20.8381C24.7578 17.577 21.2686 16.2601 18.0833 16.3364V16.3333ZM28 26.25C28.9665 26.25 29.75 27.0335 29.75 28V33.8333C29.75 34.7998 28.9665 35.5833 28 35.5833C27.0335 35.5833 26.25 34.7998 26.25 33.8333V28C26.25 27.0335 27.0335 26.25 28 26.25Z"
      fill="white"
    />
  </svg>
);

export default HeartLockedShape;
